import { FileText } from "lucide-react";
import MainButton from "../sharedComponents/MainButton";
import { useTranslation } from "react-i18next";

const EmptyState = ({ titleKey, descKey, buttonKey, onAction }) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center py-4">
            <div className="w-full max-w-md p-8 text-center border rounded-2xl bg-bg-light-secondary dark:bg-bg-dark-secondary border-border-light dark:border-border-dark">

                <FileText className="mx-auto mb-4 w-14 h-14 dark:text-primary text-primary-light" />

                <h2 className="mb-2 font-semibold text-black lg:text-xl dark:text-white">
                    {t(titleKey)}
                </h2>

                <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
                    {t(descKey)}
                </p>

                {buttonKey && (
                    <MainButton onClick={onAction}>
                        {t(buttonKey)}
                    </MainButton>
                )}
            </div>
        </div>
    );
};

export default EmptyState;
